import { BaseWorkflowRuleCollection } from '@/modules/workflow/models/BaseWorkflowRuleCollection';
import { WorkflowBillingPlanRule } from '@/modules/workflow/models/WorkflowBillingPlanRule';
import Lang from '@/modules/core/app/services/Lang';
import { WorkflowRuleType } from '/@/modules/workflow/enums/WorkflowRuleType';
import { BillingPlanMapping } from '@/modules/billing/models/BillingPlanMapping';

export class WorkflowBillingPlanRuleCollection extends BaseWorkflowRuleCollection<WorkflowBillingPlanRule> {
  constructor(items: WorkflowBillingPlanRule[] | WorkflowBillingPlanRuleCollection | undefined) {
    super(items, WorkflowBillingPlanRule);
  }

  static mapModel(
    items: WorkflowBillingPlanRule[] | WorkflowBillingPlanRuleCollection | undefined
  ): WorkflowBillingPlanRuleCollection {
    return new this(items);
  }

  get billingPlanMappings(): Array<BillingPlanMapping | undefined> {
    return (
      this.items?.map(
        (billingPlanRule: WorkflowBillingPlanRule): BillingPlanMapping | undefined =>
          billingPlanRule.billingPlanMapping
      ) ?? []
    );
  }

  sync(billingPlanSelection: BillingPlanMapping[]): void {
    super.syncRules(
      billingPlanSelection.map(
        (billingPlanMapping: BillingPlanMapping): WorkflowBillingPlanRule =>
          WorkflowBillingPlanRule.mapModel({
            billingPlanMappingId: billingPlanMapping.id,
            billingPlanMapping
          })
      )
    );
  }

  get ruleText(): string {
    return this.count > 1 ? Lang.t('workflow.billing-plan-in') : Lang.t('workflow.billing-plan-is');
  }

  get ruleType(): string {
    return WorkflowRuleType.BILLING_PLAN.key;
  }

  get ruleSelection(): BillingPlanMapping[] {
    return this.billingPlanMappings as BillingPlanMapping[];
  }
}
